import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-showcase',
  templateUrl: './notification-showcase.component.html',
  styleUrls: ['./notification-showcase.component.scss']
})
export class NotificationShowcaseComponent {
  notificationCount: number = 5;
  largeCount: number = 125;
  noCount: number = 0;
  lastNotification: string = '';

  onNotificationClick(example: string): void {
    this.lastNotification = example;
  }

  incrementCount(): void {
    this.notificationCount++;
  }

  decrementCount(): void {
    if (this.notificationCount > 0) {
      this.notificationCount--;
    }
  }

  resetCount(): void {
    this.notificationCount = 0;
  }
}
